import React, { useEffect, useState } from 'react';
import ApiDataBase from 'server';
import Chip from 'components/chip/chip';
import StyledInput from '../styledInput/StyledInput';
import { validateSalaryChange } from 'helper/salaryRules';

/**
 * @param previousSalary  the rate before editing — a raise is free, a cut is not
 * @param hasContract     whether a contract has been generated for the mission
 * @param onValidityChange called with false while the rate would be refused
 */
const Salary = ({
  salary,
  onChange,
  previousSalary,
  hasContract = false,
  onValidityChange,
}) => {
  const [smic, setSmic] = useState('');
  const [salaryData, setSalaryData] = useState(salary || '');

  useEffect(() => {
    ApiDataBase.getMinimumWage(
      (data) => {
        if (data?.hourly?.gross) {
          setSmic(data.hourly.gross);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }, []);

  useEffect(() => {
    setSalaryData(salary || '');
  }, [salary]);

  const handleSelect = () => {
    if (salaryData === smic) {
      setSalaryData('');
      onChange('');
    } else {
      setSalaryData(smic);
      onChange(smic);
    }
  };

  // An empty field is not a refusal: it is a field being filled. The form's own
  // required check has the last word on that one.
  const refusal =
    salaryData === ''
      ? null
      : validateSalaryChange({
          before: previousSalary,
          after: salaryData,
          hasContract,
          minimumWage: smic,
        });

  useEffect(() => {
    onValidityChange?.(refusal === null);
  }, [refusal?.code, onValidityChange]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSalaryData(value);
    onChange(value);
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="relative">
        <StyledInput
          type="text"
          value={salaryData}
          onChange={handleInputChange}
        />
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
          €/h
        </div>
      </div>
      {/* The design puts the refusal here, in the form, rather than in the
          confirmation modal: it is the field that is wrong. */}
      {refusal && (
        <div className={'text-sm text-red-600'}>{refusal.message}</div>
      )}
      <div className={'w-fit'}>
        <Chip
          icon={salaryData === smic}
          select={salaryData === smic}
          type={salaryData === smic ? 'SELECTON' : 'SELECTOFF'}
          onClick={handleSelect}
        >
          SMIC : {smic}€/h
        </Chip>
      </div>
    </div>
  );
};

export default Salary;